/**
 * This type describes the individual values a chart period can use.
 */

export enum chartPeriods {
    INTRADAY = "Intraday",
    // ONE_WEEK = "OneWeek",
    // TWO_WEEKS = "TwoWeeks",
    ONE_MONTH = "OneMonth",
    // TWO_MONTHS = "TwoMonths",
    // THREE_MONTHS = "ThreeMonths",
    // SIX_MONTHS = "SixMonths",
    ONE_YEAR = "OneYear",
    // TWO_YEARS = "TwoYears",
    THREE_YEARS = "ThreeYears",
    FIVE_YEARS = "FiveYears",
    MAX = "Max"
}
